import { getLinkPreviewUrl } from '../externalUrls';

export type LinkPreview = {
  url: string;
  title: string;
  description: string;
  site_name: string;
  domain: string;
  favicon_url: string | null;
};

const previewRequests = new Map<string, Promise<LinkPreview | null>>();

export function loadLinkPreview(url: string): Promise<LinkPreview | null> {
  const cached = previewRequests.get(url);
  if (cached) return cached;

  const request = fetch(getLinkPreviewUrl(url), {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
    .then(async (response) => {
      if (!response.ok) return null;
      return (await response.json()) as LinkPreview;
    })
    .catch(() => null);

  previewRequests.set(url, request);
  return request;
}
